import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Office Hours'
      breadcrumbs={[
        {
          label: 'Phone',
        },
        {
          label: 'Office Hours',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/phone/office-hours',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
